<style lang="scss" scoped>
    .snap-list{
        display: flex;
        flex-wrap: nowrap;
        .snap-item{
            position: relative;
            display: flex;
            flex-direction: column;
            margin-left: 5px;
            margin-right: 5px;
            margin-bottom: 5px;
            border: 1px solid #ececec;
            width: 213px;

            .snap-no{
                text-align: center;
                color: #9a9a9a;
                padding: 2px 0;
            }

            .snap-image{
                text-align: center;
                cursor: pointer;
                width: 213px;
                height: 40%;
                background-color: #f8f8f8;

                .el-image{
                    height: 100%;
                }

                img{
                    height: 100%;
                }
            }

            .snap-text{
                padding: 0 10px;
                font-size: 12px;
                height: 54px;
                line-height: 18px;
                color: #555;
                display:-webkit-box;
                overflow:hidden;
                text-overflow:ellipsis;
                -webkit-line-clamp:3;
                -webkit-box-orient:vertical;
                margin-top: 6px;
            }

            .snap-player{
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(0,0,0,.8);
                display: none;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                i{
                    font-size: 30px;
                    color: #fff;
                }

                p{
                    color: #fff;
                    font-size: 12px;
                    color: #4d4d4d;
                }
            }

            &.active{
                border-color: $--color-primary;
                box-shadow: 0 0 0 2px rgba($--color-primary,.2);

                .snap-no{
                    color: $--color-primary;
                }
            }

            &:hover{
                .snap-player{
                    display: flex;
                }
            }
        }
    }

    .clip-list{

        .clip-item{
            margin-bottom: 15px;

            .clip-title{
                font-weight: bold;
                margin-right: 10px;
                color: #333;

                &.active{
                    color: $--color-primary;
                }
            }
            .clip-tags{
                .tag{
                    padding: 3px 6px;
                    background-color: #E6DC6A;
                    margin-left: 5px;
                    margin-top: 5px;
                    font-size: 13px;
                    display: inline-block;
                    border-radius: 2px;

                    &.Doctor{
                        background-color: #B1E9CB;
                    }
                    &.Institution{
                        background-color: #B5D3FE;
                    }
                    &.DiseaseName_ICD{
                        background-color: #F9BDC5;
                    }
                    &.Department{
                        background-color: #ce9ce8;
                    }
                }
            }
        }
    }

    .video-wrapper{
        display: flex;

        .video-area{
            margin-right: 10px;
            width: 50%;
            min-width: 50%;
            overflow: hidden;
        }

        .video-textArea{
            display: flex;
            flex: 1;

            .video-content{
                position: relative;
                flex: 1;

                .topic-table-fixed{
                    position: absolute;
                    top: 40px;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    overflow: auto;

                }
            }

            .topic-table{
                position: relative;
                width: 100%;
                z-index: 2;

                thead > tr > th{
                    font-size: 14px;
                    color: #4d4d4d;
                    font-weight: normal;
                    height: 40px;
                    text-align: left;
                    border-bottom: 1px solid #dce0ee;
                }

                tbody > tr > td{
                    padding: 10px 0;
                    text-align: left;
                    border-bottom: 1px solid #dce0ee;
                    color: #333;
                }

                .position-time{
                    color: $--color-primary;
                    visibility: hidden;
                    font-size: 18px;
                    cursor: pointer;
                }

                tbody > tr{

                    .active{
                        color: $--color-primary;
                    }
                    &:hover{
                        cursor: pointer;
                        .position-time{
                            visibility: visible;
                        }
                    }
                }
            }
        }
    }
    .uphalflayer{
      width: 100%;
      display: flex;
      height: 50vh;
       .leftbox{
        width: calc(45% - 20px);
        height: 100%;
        background: #FFFFFF;
        box-shadow: 4px 4px 6px 0px #DCE0EE, -4px -4px 6px 0px #DCE0EE;
        .leftup_tilte{
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #4D4D4D;
            padding-left: 15px;
        }
        .video-area{
          width: 100%;
          height: calc(100% - 50px);
          padding:20px;
          padding-top: 0;
          box-sizing: border-box;
        }
      }
      .rightbox{
            width: 55%;
            background: #FFFFFF;
            box-shadow: 4px 4px 6px 0px #DCE0EE, -4px -4px 6px 0px #DCE0EE;
            margin-left: 20px;
            height: 100%;
            .rightup_tilte{
              height: 50px;
              line-height: 50px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #4D4D4D;
              padding: 0 15px;
              display: flex;
              border-bottom: 1px solid #DCE0EE;
              justify-content: space-between;
            }
            .video-content{
               .topic-table-fixed{
                    height: calc(100% - 41px);
                    overflow: auto;

                }
              .topic-table{
                width: 100%;
                z-index: 2;

                thead > tr > th{
                    font-size: 14px;
                    color: #4d4d4d;
                    font-weight: normal;
                    height: 40px;
                    text-align: left;
                    border-bottom: 1px solid #dce0ee;
                }

                tbody > tr > td{
                    padding: 10px 0;
                    text-align: left;
                    border-bottom: 1px solid #dce0ee;
                    color: #333;
                }

                .position-time{
                    color: $--color-primary;
                    visibility: hidden;
                    font-size: 18px;
                    cursor: pointer;
                }

                tbody > tr{

                    .active{
                        color: $--color-primary;
                    }
                    &:hover{
                        cursor: pointer;
                        .position-time{
                            visibility: visible;
                        }
                    }
                }
            }
            }
        }
        .xgplayer-skin-default{
            height: 100% !important;
        }
    }
   .spbox{
        height: calc(50vh - 140px);
        margin: 0;
        margin-top: 20px;
        box-shadow: 4px 4px 6px 0px #DCE0EE, -4px -4px 6px 0px #DCE0EE;
        background: #fff;
        overflow: hidden;
        .header-left{
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #DCE0EE;
            ul{
              display: flex;
            }
            .listStyle{
              margin: 0 20px;
              position: relative;
              cursor: pointer;
              font-weight: 400;
              color: #4D4D4D;
              font-size: 14px;
            }
            .active{
                color: #6B7DB3;
                &::before{
                  content: "";
                  position:absolute;
                  height: 2px;
                  width: 100%;
                  bottom: 0;
                  background:#6B7DB3 ;
                }
            }
        }
        .snap-list{
          padding: 10px 15px 0 15px;
          height: calc(100% - 40px);
          overflow: auto;
          .snap-no{
              padding:0;
              height: 30px;
              line-height: 30px;
              color:#4D4D4D;;
              background: #eee;
          }
          .snap-item{
            border: none;
          }
          .snap-text{
            height: 60%;
            padding: 0;
            -webkit-line-clamp:unset
          }
        }
        .clip-list{
          padding: 20px 15px;
          height: calc(100% - 40px);
          overflow: auto;
        }
   }
</style>

<template>
    <div v-loading="loading">
      <div class="uphalflayer">
          <div class="leftbox" >
                <div class="leftup_tilte">{{title}}</div>
                <div class="video-area">
                    <Player :options="playOptions" @initPlayer="onInitPlayer" style="height:340px;padding:0"></Player>
                </div>
          </div>
          <div class="rightbox">
            <div class="rightup_tilte">
                <span>字幕展示</span>
                <span>{{currentPlayTime | time}}</span>
            </div>
            <div class="video-content"  id="video-content" style="height:calc(100% - 50px)">
                  <table class="topic-table">
                      <thead>
                      <tr style="background:#F3F5FA">
                          <th style="width: 15px">&nbsp;</th>
                          <th style="width: 130px">起止时间</th>
                          <th>字幕</th>
                      </tr>
                      </thead>
                  </table>
                  <div ref="timeline" class="topic-table-fixed">
                      <table class="topic-table">
                          <tbody>
                          <tr ref="timeText"
                              v-for="(item, index) in contents"
                              :key="index">
                              <td style="width: 15px">
                                  <el-tooltip effect="dark" content="定位到此处播放" placement="top">
                                      <i class="el-icon-video-play position-time" @click.stop="positionTime(item.StartTime)"></i>
                                  </el-tooltip>
                              </td>
                              <td style="width: 130px">
                                  {{item.StartTime | time}} - {{item.EndTime | time}}
                              </td>
                              <td :class="[currentTextIndex === index ? 'active' : '']">
                                  {{item.Text}}
                              </td>
                          </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>
      <div class="spbox">
            <div class="header-left">
                <ul>
                   <li class="listStyle" :class="type=='1'?'active':''" @click="changeTab('1')">视频关键帧</li>
                   <li class="listStyle" :class="type=='2'?'active':''" @click="changeTab('2')">视频拆条</li>
                </ul>
            </div>
            <ul v-show="type === '1'" class="snap-list" ref="snap">
                <li class="snap-item" ref="snapImage" v-for="(item, index) in slides"
                    :class="[currentImageIndex === index ? 'active' : '']"
                    :key="item.SeqNo"
                    @click="positionPlay(item)">
                    <div class="snap-no">{{item.SeqNo}}</div>
                    <div class="snap-image">
                        <el-image :src="item.ScreenshotFilePath" :lazy="index > 4"></el-image>
                    </div>
                    <span class="snap-player">
                        <i class="el-icon-video-play"></i>
                        <p>定位到此处播放</p>
                    </span>
                    <div class="snap-text">{{item.Text}}</div>
                </li>
            </ul>
            <ul v-show="type === '2'" class="clip-list">
                <li class="clip-item" v-for="item in clips">
                    <div 
                                 class="clip-title"
                                 target="_blank"
                                 :class="[item.VideoClipID == clipId ? 'active' : '']">
                        <i class="el-icon-caret-right"></i>{{item.VideoClipTitle}}
                    </div>
                    <div class="clip-tags">
                        <span v-for="(tag, key, index) in item.Tags" class="tag" :class="[key]" :key="index">{{tag}}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  import Player from '@/components/Player.vue';
  import axios from 'axios';
  import { FileBaseFolder, FileBaseFolderUrl } from '@/utils/config.js';
  import utils from '@/utils/index';
  export default {
    name: "vediobar",
    components: { Player },
    data() {
      return {
        slides: [],
        type: '1',
        contents: [],
        currentTime: 0,
        currentTextIndex: -1,
        currentPlayTime: 0,
        Jheight:"",
        currentImageIndex: -1,
        loading:true,
        clipId:0,
        id:1,
        clips:[],
        playOptions:{
            url:`http://v.quickdealservice.com/video-resources/Videos/20210603/video.mp4`,
            videoInit:true
        }
      }
    },
    filters: {
      time(second) {
        const two = (n) => n >= 0 && n < 10 ? '0' + n : '' + n;
        let hour = two(Math.floor(second / 3600000)); //整数部分代表小时；
        second %= 3600000; //余数代表 剩下的秒数；
        let minute = two(Math.floor(second / 60000));
        second %= 60000;
        let seconds = two(Math.floor(second / 1000));
        return hour > 0 ? hour + ':' + minute + ':' + seconds : minute + ':' + seconds;
      }
    },
    computed: {
      video() {
        return [];
      },
      title() {
        return '视频示例 - 假如地球突然停止自转'
      },
    },
    mounted() {
    this.getContents();
      if(this.clipId) this.type = '2';
    this.getSlides();
    this.loading=false
    },
    watch: {
      currentTime(time) {
        const positionText = () => {
          for(let i = 0, len = this.contents.length; i < len; i++) {
            let v = this.contents[i];
            let startTime = parseInt(v.StartTime / 1000),
              endTime = parseInt(v.EndTime / 1000);
            if(startTime < time && endTime > time) {
              let ref = 'timeText', $el = this.$refs[ref], currentRef = ref+i;
              if($el.length && this.$refs.timeline && this.__prevRef !== currentRef) {
                this.__prevRef = currentRef;
                this.currentTextIndex = i;
                this.$refs.timeline.scrollTop = $el[i].offsetTop - $el[i].offsetHeight;
              }
              return;
            }
          }
        };

        const positionImage = () => {
          for(let i = 0, len = this.slides.length; i < len; i++) {
            let v = this.slides[i];
            let startTime = parseInt(v.StartTime / 1000),
              endTime = parseInt(v.EndTime / 1000);
            if(startTime < time && endTime > time) {
              let ref = 'snapImage', $el = this.$refs[ref], currentRef = ref+i;
              if($el.length && this.$refs.snap && this.__prevImgRef !== currentRef) {
                this.__prevImgRef = currentRef;
                this.currentImageIndex = i;
                this.$refs.snap.scrollLeft = $el[i].offsetWidth * i;
              }
              return;
            }
          }
        };

        positionText();
        if(this.type === '1') positionImage();
      },
    },
    methods: {
      onInitPlayer(instance) {
        this.$player = instance;
        this.$player.on('timeupdate',() => {
          //console.log(this.$player.currentTime)
          this.currentTime = parseInt(this.$player.currentTime);
          this.currentPlayTime = parseInt(utils.floatMul(this.$player.currentTime, 1000));
        });
        if(this.$route.query.startTime) {
          this.positionTime(Number(this.$route.query.startTime));
        }
      },
      changeTab(info){
        this.type=info
      },
      getSlides() {
        let serviceUrl = process.env.VUE_APP_Domain+'/VideoGetSlides';
        axios({
          url: serviceUrl,
          method: 'get',
        }).then(res=>{
          if(res.data) {
            this.slides = res.data.map(v => {
              if(v.ScreenshotFilePath) {
                v.ScreenshotFilePath = v.ScreenshotFilePath.replace(/\\/g, '/');
                v.ScreenshotFilePath = 'http://v.quickdealservice.com' + v.ScreenshotFilePath;
              }
              return v;
            });
            this.loading=false;
          }
          this.slides=res.data;
        })
        //
        let serviceUrlex=process.env.VUE_APP_Domain+'/VideoClipGetAll';
        axios({
          url: serviceUrlex,
          method: 'get',
        }).then(res=>{
          if(res.data) {
            this.clips = res.data.map(v => {
              try {
                v.Tags = v.Tags ? JSON.parse("{" + v.Tags + "}") : {};
              }catch (e) {
                v.Tags = {};
              }
              return v;
            })
          }
        })
      },
      positionTime(time) {
        this.$player.currentTime = time / 1000
      },
      positionPlay(item) {
        this.positionTime(item.StartTime);
        this.currentTime = item.TextStartTime;
      },
      getContents() {
        let serviceUrl = process.env.VUE_APP_Domain+'/VideoGetContent';
        axios({
          url: serviceUrl,
          method: 'get',
        }).then(res=>{
          this.contents=res.data;
        })
      },
    }
  }
</script>